import React from 'react';
import moment from 'moment';
import I18n from 'i18n-js';

import PriceDisplay from '@reverbdotcom/commons/src/components/price_display';
import UrlHelpers from '../../shared/url_helpers';
import { get } from 'lodash';
import {
  core_apimessages_Money as Money,
} from '../../../schemas/rql';

export interface ICartItem {
  title: string;
  original_item_price?: Money;
  product_id: number;
  quantity?: number;
  eligible_sale?: {
    ends_at: string;
    discount_percent: number;
  };
  item_price: Money;
  photos: {
    _links: {
      thumbnail: {
        href: string;
      }
    }
  }[];
}

interface IProps {
  item: ICartItem;
}

function getThumbnail(photos) {
  return get(photos, '0._links.thumbnail.href');
}

function saleReminderText(eligibleSale) {
  if (eligibleSale) {
    const parsed = moment(eligibleSale.ends_at);

    return I18n.t('discovery.reverbHeader.cart.saleReminderText', {
      percentage: eligibleSale.discount_percent,
      date: parsed.format('MMM D'),
      time: parsed.format('h:mma'),
    });
  }
  return null;
}

function renderPrice({ eligibleSale, itemPrice }) {
  if (eligibleSale) {
    return (
      <span className="reverb-header__menu__item__description__discount-price">
        <PriceDisplay display={itemPrice.display} currency="USD" />
      </span>
    );
  }

  return <PriceDisplay display={itemPrice.display} currency="USD" />;
}

function ReverbHeaderCartItem({ item }: IProps) {
  const {
    title,
    photos,
    original_item_price: originalItemPrice,
    eligible_sale: eligibleSale,
    item_price: itemPrice,
    quantity,
  } = item;

  return (
    <li className="reverb-header__menu__item">
      <a
        className="reverb-header__menu__link"
        href={UrlHelpers.cartPath}
      >
        <img
          src={getThumbnail(photos)}
          alt=""
          width="96"
          height="96"
        />
        <div className="reverb-header__menu__item__description">
          {eligibleSale && (
            <p className="reverb-header__menu__item__description__sale-reminder">
              {saleReminderText(eligibleSale)}
            </p>
          )}
          <div className="reverb-header__menu__item__description__title">
            {title}
          </div>
          <small>
            {quantity && (
              <span className="mr-half">
                {`${quantity}x`}
              </span>
            )}
            {originalItemPrice && (
              <span className="mr-half opacity-60 td-line-through">
                <PriceDisplay
                  display={originalItemPrice.display}
                  currency="USD"
                />
              </span>
            )}
            {renderPrice({ eligibleSale, itemPrice })}
          </small>
        </div>
      </a>
    </li>
  );
}

export default ReverbHeaderCartItem;
